import { styled } from '@material-ui/styles';
import { TextField } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';

export const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
        color: 'white'
    },
    '& input.MuiInputBase-input': {
        color: 'white'
    },
    '& label.MuiInputLabel-outlined.MuiInputLabel-marginDense': {
        color: '#858585'
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: '#858585',   // - Set the Input border
        },
        '&:hover fieldset': {
            borderColor: 'white',
        }
    }    
});

export const CssCalendarField = styled(DatePicker)({
    '& div.MuiOutlinedInput-root': {
        height: '42px'
    },
    '& label.Mui-focused': {
        color: 'white'
    },
    '& input.MuiInputBase-input': {
        color: 'white'
    },
    '& label.MuiInputLabel-outlined.MuiInputLabel-marginDense': {
        color: '#858585'
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: '#858585',   // - Set the Input border
        },
        '&:hover fieldset': {
            borderColor: 'white',
        }
    },
    '& p.MuiFormHelperText-root.Mui-error': {
        display: 'none'
    },
    '& label.MuiFormLabel-root.Mui-error': {
        color: 'white'
    },
    '& fieldset.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#858585'
    },
    '& label.MuiFormLabel-root.Mui-error': {
        color: 'white'
    },
});

export const CssLightCalendarField = styled(DatePicker)({
    '& div.MuiOutlinedInput-root': {
        height: '42px'
    },
    '& p.MuiFormHelperText-root.Mui-error': {
        display: 'none'
    },
    '& label.Mui-focused': {
        color: 'white'
    },
    '& label.MuiFormLabel-root.Mui-error': {
        color: 'black'
    },
    '& fieldset.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0000003b'
    }
});